const React = require('react');

const Columns = require('../layout/Columns.jsx');
const CompanyAddress = require('./CompanyAddress.jsx');
const CompanyContactInfo = require('./CompanyContactInfo.jsx');
const List = require('./List.jsx');
const Logo = require('./Logo.jsx');
const Name = require('../utility/Name.jsx');
const PageHeader = require('./PageHeader.jsx');
const Separator = require('./Separator.jsx');
const Text = require('./Text.jsx');
const Utilities = require('../utility/Utilities.jsx');

function withBlockComponentHandler(WrappedComponent) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.handleComponent = this.handleComponent.bind(this);
        }

        handleComponent(d, componentData, typeHandler) {
            let BlockComponent
            let _componentData = componentData;
            let renderHeader = true;
            const type = Utilities.Config.getBlockType(d);
            switch (type) {
                case 'columnsFive':
                case 'columnsFour':
                case 'columnsSix':
                case 'columnsThree':
                case 'columnsTwo':
                    BlockComponent = Columns.V1.Component;
                    if (d.Config && d.Config.Header && d.Config.Header.renderHeaderOnlyFirst) {
                        renderHeader = componentData && componentData.index == 0;
                    }
                    if (_componentData) {
                        _componentData = [_componentData];
                    }
                    break;
                case 'companyAddress':
                    BlockComponent = CompanyAddress.Component;
                    break;
                case Name.Block.Company.ContactMeta:
                    BlockComponent = CompanyContactInfo.Component;
                    break;
                case 'listTitle':
                    if (componentData.index > 0) {
                        return null;
                    }
                    BlockComponent = List.Title.Component;
                    break;
                case 'logo':
                case Name.Block.Company.Logo:
                    BlockComponent = Logo.Component;
                    break;
                case Name.Block.Separator:
                    BlockComponent = Separator.Component;
                    break;
                case Name.Block.Text:
                    BlockComponent = Text.Component;
                    break;
                default:
                    if (typeHandler) {
                        BlockComponent = typeHandler(type);
                    }
                    if (!BlockComponent) {
                        return null;
                    }
                    break;
            }
            let blockProps = {};
            if (this.props.onBlockProps) {
                blockProps = this.props.onBlockProps(d);
            }
            let className = blockProps.className;
            if (this.props.builder) {
                if (className) {
                    className += ' draggable';
                } else {
                    className = 'draggable';
                }
                if (blockProps.active) {
                    className += ' draggable-active';
                }
            }
            let image, itemData;
            if (componentData) {
                image = componentData.image;
                itemData = componentData.itemData;
            }
            return (
                <BlockComponent
                    key={d.Id || d.id}
                    builder={this.props.builder}
                    className={className}
                    collateralType={this.props.collateralType}
                    componentData={_componentData}
                    config={blockProps.config || d}
                    data={this.props.data || {}}
                    dragging={this.props.dragging}
                    forceVisibility={this.props.forceVisibility}
                    image={image}
                    itemData={itemData}
                    renderHeader={renderHeader}
                    typeHandler={typeHandler}
                    onBlockProps={this.props.onBlockProps}
                    onClick={this.props.onClick}
                    onComponent={this.handleComponent}
                    onDragStart={this.props.onDragStart} />
            );
        }

        render() {
            return (
                <WrappedComponent {...this.props} onComponent={this.handleComponent}>
                    {this.props.children}
                </WrappedComponent>
            );
        }
    }
}

function withPageHandler(WrappedComponent, v2) {
    return class extends React.Component {
        constructor(props) {
            super(props);

            this.handlePageForItem = this.handlePageForItem.bind(this);
            this.handlePageHeader = this.handlePageHeader.bind(this);
        }

        _checkRenderOnlyFirst(d) {
            if (!d.props || !d.props.config) {
                return d;
            }
            const config = d.props.config.Config || d.props.config.config;
            if (!config || !config.Block || !config.Block.renderOnlyFirst) {
                return d;
            }
        }

        handlePageForItem(index, content, pageHeader, pageClassName) {
            if (this.props.builder) {
                return content;
            }
            let contentAfter = this.props.contentAfter;
            if (contentAfter && index > 0) {
                contentAfter = contentAfter.filter(this._checkRenderOnlyFirst);
            }
            let contentBefore = this.props.contentBefore;
            if (contentBefore && index > 0) {
                contentBefore = contentBefore.filter(this._checkRenderOnlyFirst);
            }
            let _pageClassName = 'pageContainer';
            if (pageClassName) {
                _pageClassName += ` ${pageClassName}`;
            }
            let style;
            if (v2) {
                if (this.props.onPageProps) {
                    const pageProps = this.props.onPageProps();
                    if (pageProps && pageProps.config && pageProps.config.Style) {
                        style = Utilities.Config.getStyleV2(pageProps.config.Style);
                    }
                } else if (this.props.collateralConfig.Config && this.props.collateralConfig.Config.document && this.props.collateralConfig.Config.document.config && this.props.collateralConfig.Config.document.config.Style) {
                    style = Utilities.Config.getStyleV2(this.props.collateralConfig.Config.document.config.Style)
                }
            }
            let contentStyle;
            if (this.props.collateralType == 2 || this.props.collateralType == 3) {
                contentStyle = { verticalAlign: 'baseline' }
            }
            return (
                <table key={index} border="0" cellPadding="0" cellSpacing="0" className={_pageClassName} style={style} width="100%">
                    <tbody>
                        {
                            (this.props.forcePageHeader || index == 0 || this.props.collateralType == 1) &&
                            <tr className={this.props.preview ? 'pageHeader' : undefined}>
                                <td>{pageHeader}</td>
                            </tr>
                        }
                        {
                            contentBefore != undefined &&
                            contentBefore.length > 0 &&
                            <tr>
                                <td>
                                    {contentBefore}
                                </td>
                            </tr>
                        }
                        <tr>
                            <td style={contentStyle}>
                                {content}
                            </td>
                        </tr>
                        {
                            contentAfter != undefined &&
                            contentAfter.length > 0 &&
                            <tr>
                                <td>
                                    {contentAfter}
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            );
        }

        handlePageHeader() {
            let pageHeader;
            if (this.props.onComponent && this.props.collateralConfig) {
                if (this.props.collateralConfig.PageHeaderBlocks) {
                    pageHeader = this.props.collateralConfig.PageHeaderBlocks.map((d) => this.props.onComponent(d))
                } else {
                    pageHeader = <PageHeader {...this.props} contentConfig={this.props.collateralConfig} />
                }
            }
            return pageHeader;
        }

        render() {
            return (
                <WrappedComponent {...this.props} onPageForItem={this.handlePageForItem} onPageHeader={this.handlePageHeader}>
                    {this.props.children}
                </WrappedComponent>
            );
        }
    }
}

module.exports = {
    withBlockComponentHandler,
    withPageHandler
};